import { useCallback, useEffect, useState } from 'react';
import Papa from 'papaparse';
import { inventorySource } from '../data/inventorySource';
import { Car } from '../types/car';
import { normalizeHeader, parseInventoryRows } from '../utils/inventory';

export type InventoryStatus = 'loading' | 'ready' | 'error';

function inventoryUrl(): string {
  if (inventorySource.publishedCsvUrl) return inventorySource.publishedCsvUrl;
  const sheet = encodeURIComponent(inventorySource.sheetName);
  return `https://docs.google.com/spreadsheets/d/${inventorySource.spreadsheetId}/gviz/tq?tqx=out:csv&sheet=${sheet}`;
}

export function useInventory() {
  const [cars, setCars] = useState<Car[]>([]);
  const [status, setStatus] = useState<InventoryStatus>('loading');

  const reload = useCallback(async () => {
    setStatus('loading');
    try {
      const res = await fetch(inventoryUrl(), { cache: 'no-store' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const text = await res.text();
      const parsed = Papa.parse<Record<string, string>>(text, {
        header: true,
        skipEmptyLines: true,
        transformHeader: normalizeHeader,
      });
      if (!parsed.meta.fields?.includes('id')) throw new Error('La pestaña no tiene columna ID');
      const { cars: next, issues } = parseInventoryRows(parsed.data);
      if (issues.length) console.warn('Inventario VCARS — filas no publicadas:\n' + issues.join('\n'));
      setCars(next);
      setStatus('ready');
    } catch (err) {
      console.error('No se pudo cargar el inventario', err);
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { cars, status, reload };
}
